import { React } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Grid, ListItem, Paper, Tooltip } from '@material-ui/core';
import { GoTasklist } from "react-icons/go";
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: "flex",
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
  },
  tableAction2: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center",
    color: '#0088FE',
    fontSize: '26px',
    cursor: 'pointer',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paperModal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  paperContent: {
    backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 1),
    borderRadius: '10px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    padding: theme.spacing(3),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    marginTop: '-3%',
    marginBottom: '3.2%'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default function ListQuestion({ idPoll, rows, isLoadUser, handledEditQuestion, primaryColor }) {
  const clases = useStyles()
  const history = useHistory();
  const handleRowClick = (row) => {
    history.push(`/polls/preguntas/respuestas/${row.id}/${idPoll}`);
  }

  const changeFormatDate = (date) => {
    let fecha = new Date(date);
    let año = fecha.getFullYear();
    let mes = fecha.getMonth() + 1;
    let day = fecha.getDate();
    mes = mes < 10 ? `0${mes}` : mes;
    day = day < 10 ? `0${day}` : day;
    fecha = `${año}-${mes}-${day}`


    return fecha
  }


  return (
    <>
      {isLoadUser ? (
        < Paper className={clases.card}>
          <CircularProgress style={{ marginLeft: '60%' }} />
        </Paper>
      ) : (
        rows && rows.length > 0 ? (
          rows.map((row) => (
            < Paper className={clases.card}>
              <Grid container spacing={1}>
                <Grid item style={{ width: '20%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
                  {changeFormatDate(row.created)}
                </Grid>
                <Grid item style={{ width: '40%', paddingLeft: '0%', fontWeight: 'bold', fontSize: '16px', paddingRight: '5%' }}>
                  {row.description}
                </Grid>
                <Grid item xs={2} style={{ width: '20%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
                  {row.type}
                </Grid>
                <Grid item xs={1} style={{ width: '5%', paddingLeft: '0%' }} onClick={() => { handledEditQuestion(row) }}>
                  <ListItem button>
                    <Tooltip title="Editar" aria-label="top-end">
                      <EditIcon className={clases.tableAction} style={{ color: primaryColor }} />
                    </Tooltip>
                  </ListItem>
                </Grid>
                {row.type === 'C' &&
                  <Grid item xs={1} style={{ width: '5%', paddingLeft: '0%' }} onClick={() => { handleRowClick(row) }}>
                    <ListItem button>
                      <Tooltip title="Respuestas" aria-label="top-end" y>
                        <GoTasklist className={clases.tableAction2} style={{ color: primaryColor }} />
                      </Tooltip>
                    </ListItem>

                  </Grid>
                }
              </Grid>
            </Paper>
          ))

        ) : (
          < Paper className={clases.card}>
            <Grid container spacing={1}>
              <Grid item style={{ width: '60%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
                No hay preguntas para esta encuesta.
              </Grid>
            </Grid>
          </Paper>
        )
      )}
    </>
  );
}